import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import '../../css/editor.css';
import ApiService from '../../../../services/api';
import Organization from '../../../../media/organization.png';
import Add from '../../../../media/add.png';
import AdminSelect from './admin_select';
import Back from '../../../../media/back.png';

const CreateOrganization = () => {
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [countries, setCountries] = useState([]);
  const [coursesList, setCoursesList] = useState([]);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    email: '',
    nation: '',
    city: '',
    create_admin: true,
    admin_first_name: '',
    admin_last_name: '',
    admin_tax_id: '',
    courses: []
  });

  useEffect(() => {
    ApiService.getCourses().then(setCoursesList);
    ApiService.getCountries().then(setCountries);
  }, []);

  const validate = () => {
    const errs = {};

    if (!form.name.trim()) errs.name = 'Campo obbligatorio';
    if (!form.nation) errs.nation = 'Campo obbligatorio';
    if (form.create_admin) {
        if (!form.admin_first_name)
            errs.admin_first_name = 'Campo obbligatorio';

        if (!form.admin_last_name)
            errs.admin_last_name = 'Campo obbligatorio';

        if (!form.email)
            errs.email = ['Campo obbligatorio', true];

        if (!form.admin_tax_id)
            errs.admin_tax_id = ['Campo obbligatorio', true];
    }
    if (!form.city.trim()) errs.city = 'Campo obbligatorio';

    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    try {
      setSaving(true);

      const organization = await ApiService.newOrganization({
        name: form.name,
        email: form.email,
        nation: form.nation,
        create_admin: form.create_admin,
        admin_first_name: form.admin_first_name,
        admin_last_name: form.admin_last_name,
        admin_tax_id: form.admin_tax_id,
        city: form.city,
      });

      await Promise.all(
        form.courses.map(item =>
          ApiService.createOrganizationCourse({
            organization: organization.id,
            course: item.id,
            max_users: Number(item.max_users),
            expires_at: item.expires_at || null
          })
        )
      );

      toast.success('Ente creato con successo!');

      setForm({
        name: '',
        email: '',
        nation: '',
        city: '',
        create_admin: true,
        admin_first_name: '',
        admin_last_name: '',
        admin_tax_id: '',
        courses: []
      });

      navigate('/admin/enti');

    } catch (err) {
      console.error(err);

      if (err.response && err.response.data) {
          setErrors(err.response.data);
      } else {
          toast.error('Errore durante la creazione');
      }
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (e) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const countryOptions = countries.map(c => ({
    value: c.value,
    label: c.label
  }));

   const getError = (field) => {
      if (!errors[field]) return null;

      return Array.isArray(errors[field])
        ? errors[field][0]
        : errors[field];
    };

  return (
    <form className="editor-form" onSubmit={handleSubmit}>

      <h2>
        <img src={Organization} alt="" className="section-image" />
        Crea Ente
      </h2>

      <button
        className="tab-button"
        style={{marginTop:'20px'}}
        onClick={() => navigate(`/admin/enti`)}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco degli Enti
      </button>

     
      <label>Nome *</label>
      <input
        type="text"
        name="name"
        value={form.name}
        onChange={handleChange}
        className={`input ${errors.name ? "error" : ""}`}
      />
      {errors.name && <span className="error">{errors.name}</span>}


      
      <label>Nazione *</label>
      <AdminSelect
        options={countryOptions}
        value={countryOptions.find(c => c.value === form.nation) || null}
        onChange={(selected) =>
          setForm(prev => ({
            ...prev,
            nation: selected ? selected.value : ''
          }))
        }
        placeholder="Seleziona una nazione"
      />
      {errors.nation && <span className="error">{errors.nation}</span>}

      
      <label>Città *</label>
      <input
        type="text"
        name="city"
        value={form.city}
        onChange={handleChange}
        className={`input ${errors.city ? "error" : ""}`}
      />
      {errors.city && <span className="error">{errors.city}</span>}

      <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 20 }}>
        <input
          type="checkbox"
          checked={form.create_admin}
          onChange={(e) => {
            const checked = e.target.checked;

            setForm(prev => ({
              ...prev,
              create_admin: checked,
              ...(checked
                ? {}
                : {
                    admin_first_name: '',
                    admin_last_name: '',
                    admin_tax_id: '',
                    email: '',
                  }),
            }));
          }}
        />
        Crea un amministratore per questo ente
      </label>

      {form.create_admin && (
        <>
          <label>Nome referente *</label>
          <input
            type="text"
            name="admin_first_name"
            value={form.admin_first_name}
            onChange={handleChange}
            className={`input ${errors.admin_first_name ? "error" : ""}`}
          />
          {errors.admin_first_name && <span className="error">{errors.admin_first_name}</span>}

          <label>Cognome referente *</label>
          <input
            type="text"
            name="admin_last_name"
            value={form.admin_last_name}
            onChange={handleChange}
            className={`input ${errors.admin_last_name ? "error" : ""}`}
          />
          {errors.admin_last_name && <span className="error">{errors.admin_last_name}</span>}

          <label>Email *</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            className={`input ${errors.email ? "error" : ""}`}
          />
          {getError('email') && (
            <span className="error">
              {getError('email')}
            </span>
          )}

          <label>Codice fiscale *</label>
          <input
            type="text"
            name="admin_tax_id"
            value={form.admin_tax_id}
            onChange={handleChange}
            maxLength={16}
            className={`input ${errors.admin_tax_id ? "error" : ""}`}
          />
          {getError('admin_tax_id') && (
            <span className="error">
              {getError('admin_tax_id')}
            </span>
          )}
        </>
      )}

     
      <label>Corsi abilitati</label>

      <div style={{ marginTop: 10 }}>
        {coursesList.map(course => {
          const selected = form.courses.find(c => c.id === course.id);

          return (
            <div
              key={course.id}
              style={{
                padding: 12,
                marginBottom: 10,
                border: '1px solid #e6e6e6',
                borderRadius: 10,
                backgroundColor: selected ? '#fafafa' : '#fff'
              }}
            >

             
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type="checkbox"
                  checked={!!selected}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setForm(prev => ({
                        ...prev,
                        courses: [
                          ...prev.courses,
                          {
                            id: course.id,
                            max_users: '1',
                            expires_at: ''
                          }
                        ]
                      }));
                    } else {
                      setForm(prev => ({
                        ...prev,
                        courses: prev.courses.filter(c => c.id !== course.id)
                      }));
                    }
                  }}
                />

                <span style={{ marginLeft: 10 }}>
                  {course.title}
                </span>
              </div>

              
              {selected && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent:'flex-end' }}>

                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ fontSize: 14, color: '#777' }}>
                      Data scadenza
                    </span>

                    <input
                      type="date"
                      value={selected.expires_at}
                      style={{
                        padding: 6,
                        borderRadius: 6,
                        border: '1px solid #ddd'
                      }}
                      onChange={(e) => {
                        const value = e.target.value;

                        setForm(prev => ({
                          ...prev,
                          courses: prev.courses.map(c =>
                            c.id === course.id
                              ? { ...c, expires_at: value }
                              : c
                          )
                        }));
                      }}
                    />
                  </div>

                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ fontSize: 14, color: '#777' }}>
                      Max utenti
                    </span>

                    <input
                      type="number"
                      min={1}
                      value={selected.max_users}
                      onChange={(e) => {
                        const value = e.target.value;

                        setForm(prev => ({
                          ...prev,
                          courses: prev.courses.map(c =>
                            c.id === course.id
                              ? { ...c, max_users: value }
                              : c
                          )
                        }));
                      }}
                      onWheel={(e) => e.currentTarget.blur()}
                      style={{ width: 70, textAlign: 'center' }}
                    />
                  </div>

                </div>
              )}

            </div>
          );
        })}
      </div>

      
      <button disabled={saving} type="submit" style={{ marginTop: 50 }}>
        <img src={Add} alt="" className="button-image2" />
        {saving ? 'Creazione in corso...' : 'Crea Ente'}
      </button>

    </form>
  );
};

export default CreateOrganization;